export { default as VictoryAnimation } from "./victory-animation/victory-animation";
export { default as VictoryContainer } from "./victory-container/victory-container";
export { default as VictoryLabel } from "./victory-label/victory-label";
export { default as VictoryTransition } from "./victory-transition/victory-transition";
export { default as VictoryClipContainer } from "./victory-clip-container/victory-clip-container";
export { default as VictoryTheme } from "./victory-theme/victory-theme";
export { default as VictoryPortal } from "./victory-portal/victory-portal";
export { default as Portal } from "./victory-portal/portal";
export { default as Arc } from "./victory-primitives/arc";
export { default as Border, default as Box } from "./victory-primitives/border";
export { default as ClipPath } from "./victory-primitives/clip-path";
export { default as LineSegment } from "./victory-primitives/line-segment";
export { default as Point } from "./victory-primitives/point";
export { default as Whisker } from "./victory-primitives/whisker";
export { default as addEvents } from "./victory-util/add-events";
export { default as Collection } from "./victory-util/collection";
export { default as Data } from "./victory-util/data";
export { default as DefaultTransitions } from "./victory-util/default-transitions";
export { default as Domain } from "./victory-util/domain";
export { default as Events } from "./victory-util/events";
export { default as Helpers } from "./victory-util/helpers";
export { default as Immutable } from "./victory-util/immutable";
export { default as LabelHelpers } from "./victory-util/label-helpers";
export { default as Log } from "./victory-util/log";
export { default as PropTypes } from "./victory-util/prop-types";
export { default as Scale } from "./victory-util/scale";
export { default as Selection } from "./victory-util/selection";
export { default as Style } from "./victory-util/style";
export { default as TextSize } from "./victory-util/textsize";
export { default as Timer } from "./victory-util/timer";
export { default as Transitions } from "./victory-util/transitions";
export { default as Rect } from "./victory-primitives/rect";
export { default as Path } from "./victory-primitives/path";
export { default as Line } from "./victory-primitives/line";
export { default as Circle } from "./victory-primitives/circle";
export { default as TSpan } from "./victory-primitives/tspan";
export { default as Text } from "./victory-primitives/text";
export { default as CommonProps } from "./victory-util/common-props";
export { default as Wrapper } from "./victory-util/wrapper";
export { default as Axis } from "./victory-util/axis";


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/es/index.js
// module id = ./node_modules/victory-core/es/index.js
// module chunks = 1